import { render } from "./Collections.vue.js?vue&type=template&id=319dd1a9!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Collections.vue?vue&type=template&id=319dd1a9"
import script from "./Collections.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Collections.vue?vue&type=script&lang=js"
export * from "./Collections.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Collections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/Collections.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "319dd1a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('319dd1a9', __exports__)) {
    api.reload('319dd1a9', __exports__)
  }
  
  module.hot.accept("./Collections.vue.js?vue&type=template&id=319dd1a9!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Collections.vue?vue&type=template&id=319dd1a9", () => {
    api.rerender('319dd1a9', render)
  })

}


export default __exports__